import { useEffect, useMemo, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import { useDispatch } from 'react-redux';

import { cambiarStatusProyecto } from '../../../actions/proyectos';

const opcionesStatus = [
    { value: 1, label: 'Activo' },
    { value: 3, label: 'Pausado' },
    { value: 4, label: 'Terminado' },
    { value: 5, label: 'Cancelado' },
    { value: 6, label: 'Eliminado' }
];

const CambiarStatusProyectoModal = ({ show, onHide, onSuccess, proyecto }) => {
    const dispatch = useDispatch();

    const [statusSel, setStatusSel] = useState(null);
    const [guardando, setGuardando] = useState(false);

    useEffect(() => {
        if (!show) {
            setStatusSel(null);
            setGuardando(false);
            return;
        }

        const actual = opcionesStatus.find(s => s.value === Number(proyecto?.status));
        setStatusSel(actual || null);
    }, [show, proyecto]);

    const puedeGuardar = useMemo(() => {
        return Boolean(proyecto?._id && statusSel?.value && !guardando);
    }, [proyecto, statusSel, guardando]);

    const onGuardar = async () => {
        if (!puedeGuardar) return;

        setGuardando(true);
        const ok = await dispatch(cambiarStatusProyecto(proyecto._id, statusSel.value));
        setGuardando(false);

        if (!ok) return;

        if (typeof onSuccess === 'function') {
            onSuccess();
        } else if (typeof onHide === 'function') {
            onHide();
        }
    };

    return (
        <Modal show={show} onHide={onHide} backdrop="static" centered>
            <Modal.Header closeButton>
                <Modal.Title>Cambiar status</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="mb-3">
                    <div className="text-muted small mb-1">Status</div>
                    <Select
                        options={opcionesStatus}
                        value={statusSel}
                        onChange={setStatusSel}
                        placeholder="Selecciona una opción..."
                        noOptionsMessage={() => 'Sin resultados'}
                    />
                </div>
            </Modal.Body>

            <Modal.Footer>
                <button type="button" className="btn btn-secondary" onClick={onHide} disabled={guardando}>
                    Cancelar
                </button>
                <button type="button" className="btn btn-primary" onClick={onGuardar} disabled={!puedeGuardar}>
                    Guardar
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default CambiarStatusProyectoModal;
